var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowFlightDouble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7383 8.8718C17.7377 9.15741 17.6337 9.44282 17.4263 9.66073L14.9079 12.3073C14.6361 12.5929 14.1954 12.5929 13.9236 12.3073C13.6518 12.0216 13.6518 11.5585 13.9236 11.2729L15.515 9.60054L4.8689 9.60054C4.4846 9.60054 4.17306 9.27316 4.17306 8.86931C4.17306 8.46546 4.4846 8.13808 4.8689 8.13808L15.515 8.13808L13.9236 6.46577C13.6518 6.18012 13.6518 5.71701 13.9236 5.43137C14.1954 5.14573 14.6361 5.14573 14.9079 5.43137L17.4263 8.0779C17.6337 8.2958 17.7377 8.58121 17.7383 8.86682C17.7383 8.86848 17.7383 8.87014 17.7383 8.8718Z",
    fill: "#8E9191"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7722 16.2968C18.7786 16.2642 18.782 16.2302 18.782 16.1952C18.782 16.192 18.782 16.1887 18.7819 16.1855C18.782 16.1816 18.782 16.1776 18.782 16.1737C18.782 15.7698 18.4705 15.4424 18.0862 15.4424L7.44013 15.4424L9.03149 13.7701C9.30331 13.4845 9.30331 13.0214 9.03149 12.7357C8.75968 12.4501 8.31898 12.4501 8.04716 12.7357L7.9375 12.851C7.86669 12.903 7.82549 12.948 7.82549 12.948L7.30314 13.5176L5.52874 15.3822C5.31813 15.6036 5.21416 15.8945 5.21685 16.1846C5.21526 16.3502 5.25082 16.5162 5.32351 16.6627C5.374 16.7719 5.44241 16.8744 5.52874 16.9651L8.04716 19.6116C8.18572 19.7572 8.36817 19.8286 8.54976 19.8258C8.56801 19.8261 8.58654 19.8251 8.60525 19.8226C8.76081 19.8071 8.91237 19.7368 9.03149 19.6116C9.3033 19.326 9.30331 18.8628 9.03149 18.5772L7.44013 16.9049L18.0862 16.9049C18.4305 16.9049 18.7165 16.642 18.7722 16.2968Z",
    fill: "#8E9191"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowFlightDouble);
export default __webpack_public_path__ + "static/media/arrow-flight-double.c491715c66d8345413d315d5ead3485a.svg";
export { ForwardRef as ReactComponent };